var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"up-main"},[_c('el-aside',{attrs:{"width":"211px"}},[_c('left-menu',{attrs:{"active":7}})],1),_c('el-main',{staticClass:"u-main"},[_c('list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }